export const LEGAL_TENDER_STATUS = {
    PENDING: "PENDING",
    VERIFIED: "VERIFIED",
    FAILED: "FAILED",
};
